import React from "react";
import "./button-row.css";
import { Link } from "react-router-dom";

function ButtonRow() {
  const clickSound = new Audio("/sounds/pop-sound.mp3");
  const handleClick = () => {
    console.log("Button clicked");
    clickSound.play().catch((error) => {
      console.error("Error playing sound:", error);
    });
  };

  return (
    <div className="button-container">
      <Link to="/" rel="noopener noreferrer">
        <button className="button" onClick={handleClick}>
          𝙷𝚘𝚖𝚎 ♡
        </button>
      </Link>

      <Link to="/commission" rel="noopener noreferrer">
        <button className="button" onClick={handleClick}>
          𝙲𝚘𝚖𝚖𝚒𝚜𝚜𝚒𝚘𝚗 ☘︎
        </button>
      </Link>

      <a
        href="https://docs.google.com/spreadsheets/d/1A9ZTUm1nUTNEaXrxYL362YFy0ZSlFUXQMEsUBRGpPCY/edit?gid=0#gid=0"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="button" onClick={handleClick}>
          𝚀𝚞𝚎𝚞𝚎 𝚌𝚑𝚎𝚌𝚔 ↗︎
        </button>
      </a>

      <a
        href="https://www.deviantart.com/mildmisaki"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="button" onClick={handleClick}>
          ★*..𝙰𝚍𝚘𝚙𝚝𝚊𝚋𝚕𝚎..*★ ↗︎
        </button>
      </a>

      <Link to="/contact-me" rel="noopener noreferrer">
        <button className="button" onClick={handleClick}>
          𝙲𝚘𝚗𝚝𝚊𝚌𝚝 𝚖𝚎 ✉
        </button>
      </Link>

      <Link to="/my-zone" rel="noopener noreferrer">
        <button className="button" onClick={handleClick}>
          𝙼𝚢 𝚣𝚘𝚗𝚎 ♡
        </button>
      </Link>
    </div>
  );
}

export default ButtonRow;
